var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_53_32",
    transform: "translate(0.0238095) scale(0.010582 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_53_32",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAD2UlEQVR4nO2cPWsUQRiAH6MkOUHEys9a0R8g6B+QKBaCrfoHtFJMrLQxpYgfkFgG7IyNhZWChVoqEW2CoJCIgiRikjMXJWuxd3pcdmY/bvadnc37wDS3t/O+89zsu7N7tweKoiiKogTHgO8E6k4DuAf8aLe77dcUx9wGop52y2tGNeUrG0V/85pRDrb4TiAHkeH1IMagJxYhVLQQvaK3A/eJz+q99dB3M+E7r962SLw6sq6IJiqQaF3aRLfY7hPJALCMrk1d0QR2AOugNVqMbtHrwJSvRGrIFO3ZnESD+NJ2Ef81LtS2ANyhpwTbFvuRZZtiJtGp1mghVLQQKloIFS2EihZCRQuhooVQ0UKo6P+0gDFgb7uNAWsSgX1fykq2VWAkwcFYgb5y43vwUq0FnDY42F2gv0Q2e+lYA84CTwzbt7oKtM1VRwHSAs4ATy3vuSCRiO9DusxmqsndjLTf56R02PAto6xmq8kdTgC/CvafG99CQpSsopGRHKzoVWAU2NNuoxSrm2XW5OBFm2Zg3lknNZODFJ0mJ6sYaclBic4iB9IF+ZAcjOiskjuYRPmSHITovJI79ArzKVlcdIt8q4UsqwIbnRWD5OqiEqJHcwwwqxxX7ylTsrjoPYY++znMi5YWU+xai+4ecJFa6qqO10b0WErf/Rzmeeu5RLnwJtrVya3f/qUli4uOKP8wd3X1GLzoIrJd3cfwJdmb6IjyD/NVNv5MQLpcVEJ0lpntcwbWSrRNdp0kV0J0RPUOczHR+gyLe/QZFp+oaCFUtBAqWggVLYSKFkJFC6GihbCJXhbLoj78NG2wif5QQiJ1x+jMJvphCYnUnULOhoC3+L9JE0p7AwwWEQ1wAJWdVfL+go7/MQRcAl4DSxUYVFXaEvAKuEgfM9kHw8Bnkgf1ifgD72UQ+GjYZw79a7lErmCePecs+5237He5xHyDZCfwnWRZM9hXRwPENTJp3wVgV2lZB8g45ll5MsP+pyz73ywh3yDZB6yQLOlFjn6eGfpoEq+eNj0PMM/GYzn6OUr8z4lJ/Uw6zDdIDgG/SZbzqEB/04a+/gBHHOQbLI8xizlcoL+DmD+4aQf5BontUJ+w7JfGpKHPCDjeR7/BMUT86MU8yTJWiE+QRbGdXOfasZMufmpFA3iO/dJ23EEc23IxIl6hDDuIU1muYRfg6gLDdgHUaVcdxKks77EPfsZhrHeCsSpH2q9Gmw5jNQVjpSL95ex8yvY5h7G+CMZKRVp02lc9Lr8+k4xVORrEN8uTDuWXuL1/LBmrkjSAG8As8VMAs8B1yhm4ZCxFURTX/AUfrqBd91P7HQAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.87b35afda7c576e8d23de1ded737eb0f.svg";
export { ForwardRef as ReactComponent };